import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { invoiceAPI, customerAPI } from '../services/api';
import './Dashboard.css';

function Dashboard() {
  const [stats, setStats] = useState({
    totalInvoices: 0,
    totalCustomers: 0,
    recentInvoices: []
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      const [invoicesRes, customersRes] = await Promise.all([
        invoiceAPI.getAll(),
        customerAPI.getAll()
      ]);

      const invoices = invoicesRes.data;
      const recentInvoices = invoices.slice(0, 5);

      setStats({
        totalInvoices: invoices.length,
        totalCustomers: customersRes.data.length,
        recentInvoices
      });
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadgeClass = (status) => {
    const statusClasses = {
      draft: 'badge-draft',
      sent: 'badge-sent',
      paid: 'badge-paid',
      overdue: 'badge-overdue',
      cancelled: 'badge-cancelled'
    };
    return statusClasses[status] || 'badge-default';
  };

  if (loading) {
    return <div className="loading">Loading dashboard...</div>;
  }

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h2>Dashboard</h2>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon">📄</div>
          <div className="stat-content">
            <h3>{stats.totalInvoices}</h3>
            <p>Total Invoices</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">👥</div>
          <div className="stat-content">
            <h3>{stats.totalCustomers}</h3>
            <p>Total Customers</p>
          </div>
        </div>
      </div>

      <div className="quick-actions">
        <h3>Quick Actions</h3>
        <div className="action-buttons">
          <Link to="/invoices/new" className="btn btn-primary">
            Create New Invoice
          </Link>
          <Link to="/customers/new" className="btn btn-secondary">
            Add New Customer
          </Link>
        </div>
      </div>

      <div className="recent-invoices">
        <div className="section-header">
          <h3>Recent Invoices</h3>
          <Link to="/invoices" className="link">View All</Link>
        </div>

        {stats.recentInvoices.length === 0 ? (
          <p className="empty-message">No invoices yet. Create your first invoice!</p>
        ) : (
          <table className="data-table">
            <thead>
              <tr>
                <th>Invoice #</th>
                <th>Customer</th>
                <th>Date</th>
                <th>Total</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {stats.recentInvoices.map((invoice) => (
                <tr key={invoice._id}>
                  <td>
                    <Link to={`/invoices/edit/${invoice._id}`} className="link">
                      {invoice.invoiceNumber}
                    </Link>
                  </td>
                  <td>{invoice.customerSnapshot.name}</td>
                  <td>{new Date(invoice.invoiceDate).toLocaleDateString()}</td>
                  <td>${invoice.total.toFixed(2)}</td>
                  <td>
                    <span className={`badge ${getStatusBadgeClass(invoice.status)}`}>
                      {invoice.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default Dashboard;
